import { Routes, Route } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import Dashboard from './pages/Dashboard';
import TripDetail from './pages/TripDetail';
import NewTrip from './pages/NewTrip';
import Settings from './pages/Settings';
import Calendar from './pages/Calendar';
import MileageSweetSpot from './pages/MileageSweetSpot';
import Insurance from './pages/Insurance';

export default function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/mileage-sweet-spot" element={<MileageSweetSpot />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/trip/:id" element={<TripDetail />} />
        <Route path="/new" element={<NewTrip />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
